import { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'
import WshSupportModal from '@wsh/WshSupportModal'

interface SupportModalContextType {
  openSupport: () => void
}

const SupportModalContext = createContext<SupportModalContextType | undefined>(undefined)

export function SupportModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)

  return (
    <SupportModalContext.Provider value={{ openSupport: () => setOpen(true) }}>
      {children}
      <WshSupportModal show={open} onHide={() => setOpen(false)} />
    </SupportModalContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSupport() {
  const context = useContext(SupportModalContext)
  if (context === undefined) {
    throw new Error('useSupport must be used within a SupportModalProvider')
  }
  return context
}
